import { render, staticRenderFns } from "./ViewButton.vue?vue&type=template&id=4a967f3e&"
import script from "./ViewButton.vue?vue&type=script&lang=ts&"
export * from "./ViewButton.vue?vue&type=script&lang=ts&"
import style0 from "./ViewButton.vue?vue&type=style&index=0&id=4a967f3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports